import { Menu, Button, Typography, Drawer } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  MenuFoldOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { HiOutlineUser, HiOutlineCake } from "react-icons/hi";
import { VscBookmark } from "react-icons/vsc";
import { BiUserPlus } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import User from "../assets/profile2.JPG";
import { toggleSideBar } from "../state/action";

const { Title } = Typography;

const SideBar = () => {
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    dispatch(toggleSideBar());
  };
  return (
    <div style={{ width: "auto" }} className="sideBar">
      <Button
        type="primary"
        className="sideBurger"
        onClick={() => toggleCollapsed()}
        style={{
          marginBottom: 0,
          borderWidth: 0,
          background: "transparent",
          padding: 0
        }}
      >
        {React.createElement(collapsed ? AiOutlineClose : MenuFoldOutlined)}
      </Button>
      <div>
        <Drawer
          placement={"left"}
          width={500}
          onClose={toggleCollapsed}
          visible={collapsed}
        >
          <Menu
            defaultSelectedKeys={["0"]}
            defaultOpenKeys={["sub1"]}
            mode="inline"
          >
            <div className="mt-5 mb-10">
              <div className="w-28 h-28 rounded-full block lg:flex overflow-hidden">
                <img src={User} />
              </div>
              <Title level={4}>Victor Chinedu</Title>
              <label style={{marginTop: 10}}>@victorr</label>
            </div>
            <Menu.Item
              key="1"
              style={{paddingLeft: 0 }}
              icon={
                <HiOutlineUser
                  style={{ fontSize: "25px", color: "#000", marginRight: "10px" }}
                />
              }
            >
            Profile
            </Menu.Item>
            <Menu.Item
              key="2"
              style={{paddingLeft: 0 }}
              icon={
                <TeamOutlined
                  style={{ fontSize: "25px", color: "#000", marginRight: "10px" }}
                />
              }
            >
            Forums
            </Menu.Item>
            <Menu.Item
              key="3"
              style={{paddingLeft: 0 }}
              icon={
                <VscBookmark
                  style={{ fontSize: "25px", color: "#000", marginRight: "10px" }}
                />
              }
            >
            Saved Post
            </Menu.Item>
            <Menu.Item
              key="4"
              style={{paddingLeft: 0 }}
              icon={
                <HiOutlineCake
                  style={{ fontSize: "25px", color: "#000", marginRight: "10px" }}
                />
              }
            >
            Birthdays
            </Menu.Item>
            <Menu.Item
              key="5"
              style={{paddingLeft: 0 }}
              icon={
                <BiUserPlus
                  style={{ fontSize: "25px", color: "#000", marginRight: "10px" }}
                />
              }
            >
            News Room
            </Menu.Item>
            <Menu.Item
              key="5"
              style={{paddingLeft: 0 }}
              icon={
                <BiUserPlus
                  style={{ fontSize: "25px", color: "#000", marginRight: "10px" }}
                />
              }
            >
            Support
            </Menu.Item>
            <div className="mt-10">
              <Title level={5} style={{ marginBottom: 20 }}>
              Settings and Privacy
              </Title>
              <Title level={5}>Help Center</Title>
            </div>
          </Menu>
        </Drawer>
      </div>
    </div>
  );
};

export default SideBar;
